import React from 'react';

import CN from './WidgetTitle.module.scss';

const WidgetTitle = ({ tag, children }) => (
  <div data-bem="WidgetTitle" data-tag={tag} className={CN.component}>
    {children}
  </div>
);

export default WidgetTitle;
